@if (isInitialized && isMeterAsymmetric !== null) {
  <oe-chart [title]="component.alias +  '&nbsp;-&nbsp;' + ('EDGE.HISTORY.CURRENT_AND_VOLTAGE' | translate)"
    [showPhases]="showPhases" [showTotal]="showTotal" (setShowTotal)="setShowTotal($event)"
    (setShowPhases)="setShowPhases($event)" [period]="service.historyPeriod.value">
    <pickdate custom-pickdate [historyPeriods]="['day', 'week']"></pickdate>
    @if (isMeterAsymmetric) {
      <currentVoltageAsymmetricChart [isOnlyChart]="true"></currentVoltageAsymmetricChart>
    }
    @if (!isMeterAsymmetric) {
      <currentVoltageChart [isOnlyChart]="true"></currentVoltageChart>
    }
    <oe-footer-subnavigation [backButton]="true" [navigationOptions]="[]"></oe-footer-subnavigation>
  </oe-chart>
}
